import React from 'react'

import { ONBOARDING_PINNED_APP_ID } from 'shared/hooks/useOnboarding'
import { AppConfig } from 'shared/types/app'

import { AppButton } from '../../../AppButton'
import { transformAppConfigToAppData } from '../../../AppButton/utils/appDataTransform'
import { LaunchPadProps } from '../../LaunchPad.types'

export interface AppIconRendererProps {
  app: AppConfig
  index: number
  isLocked: boolean
  isLoading?: boolean
  buttonType: 'launchpad'
  size?: 'medium' | 'large'
  variant?: 'light' | 'dark'
  iconRefs: LaunchPadProps['iconRefs']
  contextMenuRef?: LaunchPadProps['inventoryAppContextMenuRef']
  onAppClick: (appData: ReturnType<typeof transformAppConfigToAppData>) => void
  onCloseLaunchpad: () => void
}

export const AppIconRenderer: React.FC<AppIconRendererProps> = ({
  app,
  index,
  isLocked,
  isLoading,
  buttonType,
  size = 'medium',
  variant = 'light',
  iconRefs,
  contextMenuRef,
  onAppClick,
  onCloseLaunchpad
}) => {
  const appData = transformAppConfigToAppData(app)

  const handleClick = () => {
    if (isLocked) {
      return
    }
    onCloseLaunchpad()
    onAppClick(appData)
  }

  return (
    <div key={app.id}>
      <AppButton
        buttonType={buttonType}
        contextMenuRef={
          app.id === ONBOARDING_PINNED_APP_ID ? contextMenuRef : undefined
        }
        key={app.id!}
        tourId={`launchpad-${app.id!}`}
        iconRefs={iconRefs}
        index={index}
        isLocked={isLocked}
        isLoading={isLoading}
        size={size}
        variant={variant}
        app={appData}
        onClick={handleClick}
      />
    </div>
  )
}
